import { render, staticRenderFns } from "./item1.vue?vue&type=template&id=8a9a3ba4&scoped=true"
import script from "./item1.vue?vue&type=script&lang=js"
export * from "./item1.vue?vue&type=script&lang=js"
import style0 from "./item1.vue?vue&type=style&index=0&id=8a9a3ba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9a3ba4",
  null
  
)

export default component.exports